import ProjectUserFull from "../project-user/project-user-full";
import {ProjectAccessMode} from "../project/types";

export enum TagType {
    GENERIC,
    PROJECT
}

export enum TagScope {
    GLOBAL  = 'global',
    PROJECT = 'project'
}

export const tagScopeOptions: Options = [
    {
        value       : TagScope.GLOBAL,
        label       : "All Projects",
        icon        : "i5-globe",
        description : "This tag can be applied to tasks in any project.",
    },
    {
        value       : TagScope.PROJECT,
        label       : "Project-specific",
        icon        : "i5-project",
        description : "This tag can be applied only to tasks in the parent project and its subprojects.",
    },
]

export const typeItems = [
    {
        items: [
            {
                typeId         : TagType.GENERIC,
                svgIcon50      : 'isvg-generic-tag',
                title          : 'Tag',
                description    : 'Create a tag to categorize and organize items across your workspace.'
            }, {
                typeId         : TagType.PROJECT,
                svgIcon50      : 'isvg-project-tag',
                title          : 'Project Tag',
                description    : 'A tag available within a specific folder or project, automatically accessible across its structure.'
            }
        ]
    }
];

export const accessOptions = [
    {
        id          : ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN,
        label       : "Public",
        icon        : 'i5-globe',
        description : 'Visible to all users'
    },
    {
        id          : ProjectAccessMode.TAG_SHARED,
        label       : "Shared",
        icon        : 'i5-users',
        description : 'Shareable with others'
    },
    {
        id          : ProjectAccessMode.INHERITANCE_PARENT_CHILDREN,
        label       : "Private",
        icon        : 'i5-lock',
        description : 'Visible only to you'
    },
]

export type TypeInitParams = {
    projectId   : ID
    type        : TagType
    access      : ProjectAccessMode
    projectUsers: ProjectUserFull[]
    callback    : callback
}
